module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//main-table.png?v=56f5550d";